<template>
    <!-- 工厂档案访问分析 -->
    <div class="col-chart-box">
        <div class="col-chart-head line">
            <div class="left">
                <div class="left-title">工厂档案访问分析</div>
            </div>
        </div>
        <div v-loading="loading" class="col-chart-view" style=" display: flex;justify-content: center;">
            <div ref="echart" style=" height: 246px;width:100%;"></div>
        </div>


        <!-- <div class="bottom">
            <div class="bottom-first">
                <p>档案被查看：<span style="color:#066EB7">1899次</span> </p>
                <p>设备清单被查看：<span style="color:#066EB7">104次</span></p>
            </div>
            <div class="bottom-second">
                <p>联系方式被查看：<span style="color:#066EB7">145次</span></p>
                <p>产品被查看：<span style="color:#066EB7">99次</span></p>
            </div>
        </div> -->
    </div>
</template>

<script>
import windowAddEvent from '@/utils/windowAddEvents';
import {  getDataAssistant } from "@/utils/api/dashboard";

export default  {
    props:{
        startTime:{
            typeof:String,
            default:''
        },
        endTime:{
            typeof:String,
            default:''
        },
      
    },
    data(){
        return {
            echartsObj:  '',
            fileBrowsingData: {},
            loading : false
        }
    },
    watch: {
        startTime: {
            handler(newVal) {
                if(newVal) {
                    this.getFileBrowsingData()
                }
            },
        }
    },
    methods:{
        //获取数据
        getFileBrowsingData(){
            this.loading = true;
            const params = {
                startDate: this.startTime,
                endDate: this.endTime,
                enums:['VISITED_SOURCE']
            }
            getDataAssistant(params)
            .then((res)=>{
                const bizCode = res.rspResult.bizCode;
                const codeArr = [401, 403, 404];
                if(bizCode === 200){
                    this.fileBrowsingData = res.data || {};
                    this.init();
                    this.loading = false;
                }else if (!codeArr.includes(bizCode)) {
                    this.loading = false;
                    this.$message.error(res.data.rspResult.message);
                }
            })
            .catch((err)=>{
                this.loading = false;
                this.$message.error("System error",err);
            })
        },

        init() {
            let options = {
                tooltip: {
                    trigger: "axis"
                },
               
                radar: [
                    {
                        indicator: [
                            { text: '查看公司档案',color:"#4F5D78", max: this.fileBrowsingData.viewProfile+150 },
                            { text: '查看设备清单',color:"#4F5D78", max: this.fileBrowsingData.viewEquip+50 },
                            { text: '查看联系方式',color:"#4F5D78", max: this.fileBrowsingData.viewContact+50 },
                            { text: '查看产品',color:"#4F5D78",max: this.fileBrowsingData.viewProduct+50 }
                        ],
                        center: ['50%', '50%'],
                        radius: 91,
                        axisLine: {
                            show: false, //雷达图中心发出的射线：坐标轴轴线相关设置
                        },
                       
                    },
                ],
                series: [
                    {
                        type: 'radar',
                        tooltip: {
                            trigger: 'item'
                        },
                        areaStyle: {
                            normal:{
                                opacity: 0.2 ,
                                color:"#3A69F4"
                            }
                        },
                        data: [
                            {
                            value: [
                                this.fileBrowsingData.viewProfile, 
                                this.fileBrowsingData.viewEquip, 
                                this.fileBrowsingData.viewContact,
                                this.fileBrowsingData.viewProduct, 
                            ],
                            name: '访问统计'
                            }
                        ],
                        symbol: "circle", // 焦点的样式，还可以取值'rect','angle'等
                        symbolSize: 5, // 焦点的大小
                        itemStyle: {
                            //拐点空心圆空心圆
                            normal: {
                                color: "#fff",
                                borderColor: '#3A69F4',
                                borderWidth: 0.4,
                                lineStyle: {
                                    width: 1,
                                    color: "#3A69F4",
                                },
                            },
                        },
                    },
                ]
              
            };
            this.echartsObj.clear();
            this.echartsObj.setOption(options);
        },
    },
    mounted() {
        let ele = this.$refs.echart;
        this.echartsObj = this.$echarts.init(ele);
        this.getFileBrowsingData()
        windowAddEvent('resize', this.echartsObj.resize);
    },

}
</script>

<style lang="scss" scoped>
.bottom{
    padding: 0 40px 20px 20px;
    color: #4F5D78;
    &-first,&-second{
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        line-height: 20px;
    }


}
</style>